import {handleActions} from 'redux-actions';
import Constants from './constants';

import SettingsConstants from '../settings/constants';

import ITeamState from './state';
import { DefaultTeam, ITimer as Timer} from './types';
import {isTimerRunning} from "./selectors";

export const initialState = {
    fetching: true,
    isPending: false,
    team: DefaultTeam,
} as ITeamState;

export default handleActions(
    {
        [Constants.START_TIMER_PENDING]: (state: ITeamState) => ({
            ...state,
            fetching: true,
            isPending: true,
        }),
        [Constants.START_TIMER_SUCCESS]: (state: ITeamState, data: any) => ({
            ...state,
            fetching: false,
            isPending: false,
            team: {
                ...state.team,
                timer: data.payload.timer,
            },
        }),
        [Constants.STOP_TIMER_SUCCESS]: (state: ITeamState) => ({
                ...state,
                isPending: false,
                timerRunning: false,
            }),
        [Constants.FETCH_TEAM_SUCCESS]: (state: ITeamState, data:any) => ({
            ...state,
            fetching: false,
            isPending: false,
            team: data.payload.team
        }),
        [Constants.TIMER_STARTED]: (state: ITeamState, payload: { timer: Timer }) => {
            if(isTimerRunning(state) || state.isPending ) {
                return state;
            }

            return {
                ...state,
                isPending: false,
                timer: payload.timer,
                timerRunning: true,
            }
        },
        [Constants.TIMER_STOPPED]: (state: ITeamState) => {
            const newState  = {...state, timerRunning: false};

            delete newState.timer;

            return newState;
        },
        [SettingsConstants.SAVE_SETTINGS_SUCCESS]: (state: ITeamState, data: any) => {
            const newState = { ...state };
            newState.team!.settings = data.settings;
            return newState;
        },
        [Constants.START_TIMER_SOCKET_SUCCESS]: (state: any, data: any) => {
            const newState = { ...state, timerRunning: true };
            newState.team.timer = data.timer;
            return newState;
        },
        [Constants.CREATE_TEAM_PENDING]: (state: any, data: any) => ({ ...state }),
        [Constants.CREATE_TEAM_SUCCESS]: (state: ITeamState, data:any) => ({
            ...state,
            fetching: false,
            isPending: false,
            team: data.payload.team
        }),
        [Constants.TEAM_NOT_FOUND]: (state: any, data: any) => ({
            inTeam: false,
            lastError:  Constants.TEAM_NOT_FOUND,
            timerRunning: false,
        })
    },
    initialState,
);



// WEBPACK FOOTER //
// ./src/redux/modules/team/reducer.ts